// import { TEAM_PERMISSIONS } from "./teamManagement";

import { TEAM_PERMISSIONS } from "./teamManagement";
import { MANAGER_IMPREST_STATES } from "./pettycash";
import getUserIdentification from "../assets/getUserIdentification";

export const CONFIRM_ACCEPT_BUTTON_TEXT = "تایید";
export const CONFIRM_OK_BUTTON_TEXT = "بله";
export const CONFIRM_OK_AND_CONTINUE_BUTTON_TEXT = "تایید و ادامه";
export const CONFIRM_REJECT_BUTTON_TEXT = "انصراف";
export const WARNING_SINGLE_BUTTON_TEXT = "متوجه شدم";

export const INCLUDE_ALL_HASHTAG_AT_THE_SAME_TIME_TEXT_INFO =
  "با فعال کردن این گزینه تراکنش‌هایی قابل مشاهده خواهند بود که تمام هشتگ‌های انتخاب شده را همزمان دارا باشند.";
export const ACTION_NEED_COMPLETED_PROFILE = {
  NEW_PROJECT: "ایجاد شرکت جدید",
  ADD_MEMBER: "دعوت اعضا"
};
export const COMPLETE_USER_PROFILE_CONFIRM = actionName =>
  `برای ${actionName}، باید اطلاعات حساب کاربری خود را کامل کنید. آیا می‌خواهید اطلاعات حساب کاربری خود را کامل کنید؟`;

export const ACTION_NEED_COMPLETED_PROJECT_INFO = {
  ADD_MEMBER: "دعوت همکاران خود به این شرکت نیاز است که",
  DEFAULT_ACCOUNT_TITLE: "پیشنهاد سرفصل مرتبط با کسب و کار شما نیاز است که",
  DASHBOARD: "استفاده بهتر از نرم افزار تنخواه گردان لطفا"
};

export const COMPLETE_PROJECT_INFO_CONFIRM = actionName =>
  `برای ${actionName} اطلاعات شرکت خود را تکمیل کنید. آیا می‌خواهید اطلاعات شرکت خود را کامل کنید؟`;

export const MANAGER_CANT_ADD_TEAM_CONFIRM =
  "شما در این شرکت مدیر می‌باشید و برای ایجاد تیم تنخواه‌داری جدید از مالک یا ادمین‌های شرکت بخواهید آن تیم را ایجاد نمایند.";

export const UNKNOWN_USERS_FOR_CHIEF_TEXT = (num, typeName) =>
  `و ${num} عضو ${typeName} دیگر که در زیر مجموعه تیم شما نمی‌باشند.`;

export const INVITATION_TO_PROJECT_WITH_ROLE_TEXT = (projectName, roles) =>
  `شما به عضویت در شرکت ${projectName} به عنوان ${roles} دعوت شده‌اید. آیا دعوت‌نامه عضویت به این شرکت را قبول می‌کنید؟`;

export const MESSAGE_FOR_CLICK_ON_COSTLESS_BUDGET_ACCOUNT_TITLE =
  "هیچ هزینه‌ای برای این سرفصل‌حساب ثبت نشده است.";

export const REASON_TEXT = obj => {
  const reasonText = "reasonText" in obj ? obj.reasonText : "دلیل";
  return `${reasonText} خود را برای ${obj.action} بنویسید تا به ${obj.responsible} نمایش داده شود.`;
};

export const WARNING_WHEN_DO_NOT_HAVE_PERMISSION = permission => {
  let permissionText = "";
  switch (permission) {
    case TEAM_PERMISSIONS(true).ADMIN_TRANSACTION_ADD:
      permissionText = "ثبت تراکنش از طریق پنل مدیریت";
      break;
    case TEAM_PERMISSIONS(true).ADMIN_TRANSACTION_EDIT:
      permissionText = "ویرایش تراکنش از طریق پنل مدیریت";
      break;
    case TEAM_PERMISSIONS(true).ADMIN_TRANSACTION_DELETE:
      permissionText = "حذف تراکنش از طریق پنل مدیریت";
      break;
  }
  return `شما دسترسی ${permissionText} را ندارید. برای این منظور نیاز است که مالک یا ادمین شرکت دسترسی شما را اصلاح نمایند.`;
};

export const LOADING_TEXT = "دریافت اطلاعات...";

export const SWITCH_TO_CUSTODIAN_PANEL_DEFAULT_TEAM_PROJECT_USER = projectName => {
  return `آیا می‌خواهید به پنل تنخواه‌داری شرکت ${projectName} وارد شوید؟`;
};
export const SWITCH_TO_CUSTODIAN_PANEL_NOT_DEFAULT_TEAM_PROJECT_USER = (
  projectName,
  teamName
) => {
  return `آیا می‌خواهید به پنل تنخواه‌داری تیم ${teamName} شرکت ${projectName} وارد شوید؟`;
};
export const SWITCH_TO_MANAGER_PANEL_PROJECT_USER = projectName => {
  return `آیا می‌خواهید به پنل مدیریت شرکت ${projectName} وارد شوید؟`;
};
export const DEACTIVATED_ACCESS_IN_PROJECT_USER_FOR_NOTIFICATION_CLICK = `دسترسی شما به این گزارش تنخواه توسط مالک یا ادمین این شرکت حذف شده است. برای دسترسی به این گزارش تنخواه از مالک یا ادمین شرکت بخواهید دسترسی شما را مجددا ایجاد نمایند.`;
export const REMOVED_PROJECT_FOR_NOTIFICATION_CLICK = `شما به این گزارش تنخواه به دلیل حذف شرکت مورد نظر دسترسی ندارید.`;

export const ACCESS_DENIED_WARNING_TEXT_FOR_EDIT_PROJECT_SUB_ITEMS = projectSubItemName =>
  `شما دسترسی ایجاد و یا ویرایش ${projectSubItemName} در این شرکت را ندارید.`;

export const ACCESS_DENIED_WARNING_TEXT_FOR_EDIT_PROJECT_SUB_ITEMS_IN_TEAM = projectSubItemName =>
  `شما دسترسی ایجاد و یا ویرایش ${projectSubItemName} در این تیم تنخواه‌داری را ندارید.`;

export const ACCOUNT_TITLE_ACCOUNTING_HINT =
  "از این کد در زمان صدور اطلاعات به نرم‌افزار حسابداری استفاده خواهد شد. در صورتی که مخارج مربوط به سرفصل‌حساب فوق به تفکیک مراکز هزینه و یا طرف‌حساب نگهداری می‌شود، شما می‌توانید این عوامل را نیز در آن پیش‌بینی نمایید. برای مطالعه بیشتر به بخش راهنما مراجعه نمایید.";
export const OTHER_SUB_ITEMS_ACCOUNTING_HINT =
  "این کد به صورت یک عدد ثابت بوده و با توجه به الگوی تعریف شده برای هر سرفصل‌حساب، در فایل خروجی سند حسابداری قرار می‌گیرد.";
export const CONTACT_SERIAL_ACCOUNTING_HINT =
  "از این کد در خروجی فایل سند حسابداری برای این طرف حساب استفاده می‌شود. برای مطالعه بیشتر به بخش راهنما مراجعه نمایید.";
export const ACCOUNT_TITLE_DEFAULT_LIST_HINT =
  'لیست زیر شامل پیشنهادهای تنخواه‌گردان می‌باشد در صورت عدم تمایل به افزودن آن‌ها می‌توانید با استفاده از دکمه "+ ایجاد سرفصل‌حساب" در منوی سمت راست، سرفصل‌حساب‌های مورد نظر خود را ایجاد کنید.';
export const SELECT_DEFAULT_ACCOUNT_TITLES_LIST =
  "برای نمایش لیست پیش‌فرض، نوع آن را انتخاب کنید.";
export const CUSTODIAN_FINANCIAL_SYSTEM_ACCOUNTING_HINT =
  "در صورتی که می‌خواهید گزارشات تنخواه را مستقیما به نرم‌افزار حسابداری مالی انتقال دهید، لازم است کد حساب تنخواه‌دار در نرم‌افزار حسابداری مالی را در این بخش وارد نمایید.";
export const CUSTODIAN_SUB_SYSTEM_ACCOUNTING_HINT =
  "در صورتی که اطلاعات گزارشات تنخواه را به یکی از زیر سیستم‌های نرم‌افزار حسابداری انتقال می‌دهید، کد حساب تنخواه‌دار در آن زیر سیستم را در این بخش وارد نمایید.";

export const GENERAL_PATTERN_ACCOUNTING_HINT =
  "در این بخش می‌توانید یک الگوی پیش‌فرض برای کدینگ سرفصل‌های حساب تعریف نمایید تا در زمان تعریف کد هر سرفصل‌حساب بارگذاری شود.";
export const VAT_ACCOUNTING_HINT =
  "در این بخش کد حسابداری مالیات بر ارزش افزوده دریافتنی را وارد نمایید تا در زمان انتقال اطلاعات به نرم‌افزار حسابداری، مبالغ ارزش افزوده پرداخت شده به این حساب ثبت شوند.";

export const WARNING_TEXT_FOR_ADD_ADMIN_BY_ADMIN =
  "شما در این شرکت دارای نقش ادمین هستید و برای افزودن ادمین دیگر، ویرایش سایر ادمین‌ها و یا حذف دسترسی آن‌ها، باید مالک شرکت این کار را انجام دهد.";

export const MANAGER_ACCESS_NOTE =
  "به طور پیش‌فرض، مدیر می‌تواند در تیم‌های تنخواه‌داری مربوطه‌اش، گزارش‌های تنخواه را تایید و یا اعضای جدیدی به تیم خود اضافه کند. علاوه بر آن، شما می‌توانید دسترسی‌های زیر را به وی بدهید:";

export const PROJECT_EMPTY_STATE_TEXT =
  "شما شرکت فعالی ندارید برای ایجاد و مدیریت ‌شرکت‌ها می‌توانید از بخش تنظیمات و لیست شرکت‌ها استفاده کنید.";

export const WARNING_FOR_SELECT_AT_LEAST_ONE_ITEM =
  "هیچ‌ کدام از موارد انتخاب نشده است.";

export const DELETE_CONFIRMATION_TEXT_FOR_TOOLS_ITEM = itemName =>
  `آیا از حذف ${itemName} مورد نظر اطمینان دارید؟`;
export const ACCOUNT_TITLE_LIST_HINT_TEXT =
  "منظور از سرفصل‌های حساب، موضوعات و عنوان‌هایی هستند که برای طبقه‌بندی هزینه‌ها استفاده می‌شوند. مثلا خوراک، پیک، مواد شوینده و...";
export const SELECT_SOURCE_FOR_ADD_ACCOUNT_TITLE =
  "می‌توانید از لیست پیش‌فرض برای سرفصل‌حساب‌ها استقاده کنید.";

export const GENERAL_DELETE_CONFIRMATION_TEXT = itemName =>
  `آیا از حذف این ${itemName} اطمینان دارید؟`;
export const CHANGE_IN_PETTY_CASH_SUMMARY_CONFIRMATION_TEXT = (
  itemName,
  change,
  number
) =>
  `این ${itemName} در تنخواه شماره ${number} گزارش شده است، با ${change} آن گزارش تنخواه شماره ${number} و تنخواه‌های بعد از آن تغییر خواهند کرد. آیا از ادامه این عملیات اطمینان دارید؟`;
export const CHANGE_SENT_SUMMARY_CONFIRMATION_TEXT = (itemName, change) =>
  `${change} ${itemName}ی که در گزارش تنخواه ارسال شده می‌باشد امکان پذیر نیست. برای ${change} این موارد ابتدا باید مدیر شرکت تنخواه مربوطه را بازگشت بزند.`;
export const WARNING_TEXT_FOR_CHANGING_SENT_TRANSACTION = (itemName, change) =>
  `امکان ${change} ${itemName}ی که در یک گزارش تنخواه ارسال شده است، وجود ندارد. برای ${change} این موارد ابتدا از مدیر شرکت بخواهید تنخواه مربوطه را بازگشت دهند.`;
export const WARNING_TEXT_FOR_CHANGING_CREATED_BY_MANAGER_TRANSACTION = (
  itemName,
  change
) => `امکان ${change} ${itemName}ی که توسط مدیر ثبت شده باشد، وجود ندارد.`;

export const TEAM_LIST_HINT =
  "در این بخش می‌توانید تیم‌های مختلف تنخواه‌داری ایجاد کرده و برای هر تیم تنخواه‌داری، جریان گردش کار جداگانه تعریف نمایید. مثلا تیم تنخواه‌داری فروش، مالی، انبار و ...";
export const TEAM_SHOW_HINT =
  "در این بخش می‌توانید از طریق ایجاد  سطوح تایید، جریان گردش گزارشات تنخواه را برای هر تیم تنخواه‌داری تعریف نمایید. سطح قطعی‌سازی به صورت پیش‌فرض ساخته می‌شود و آخرین سطح گردش کار می‌باشد.";
export const TEAM_LEVEL_REORDER_HINT =
  "در این بخش می‌توانید ترتیب گزارش گردش کار سطوح مختلف را با استفاده از فلش‌های بالا و پایین تغییر دهید.";

export const SELECT_TEAM_FOR_ADD_ACCOUNT_TITLE_DEFAULT_LIST_HINT =
  "می‌خواهید سرفصل‌حساب‌های پیش‌فرض به کدام یک از تیم‌های تنخواه‌داری اضافه شود؟";

export const SELECT_TEAM_FOR_IMPORT_ACCOUNT_TITLE_HINT =
  "می‌خواهید سرفصل‌حساب‌های فایل مربوطه به کدام یک از تیم‌های تنخواه‌داری اضافه شود؟";

export const TEAM_LIST_HINT_FOR_SUB_ITEMS = projectSubItemName =>
  `با استفاده از این بخش می‌توانید مشخص کنید که این ${projectSubItemName} در کدام یک از تیم‌های تنخواه‌داری نمایش داده شود.`;
export const CAN_NOT_DESELECT_THIS_TEAM =
  "در هنگام ثبت این فرم برداشتن تیک تیم تنخواه‌داری جاری مجاز نمی‌باشد.";

export const TEAM_SHOW_SUB_ITEMS_HINT = subItemName =>
  `در این بخش شما می‌توانید تعیین کنید که این تیم تنخواه‌داری، به کدام یک از ${subItemName} دسترسی داشته باشد. تنخواه‌داران این تیم، در هنگام ثبت پرداخت‌ها و دریافت‌های خود، تنها مجاز به انتخاب از بین ${subItemName}‌ی تعیین شده خواهند بود.`;

export const TEAM_SUB_ITEM_LIST_EMPTY_STATE = subItemName =>
  `برای این شرکت هنوز ${subItemName} ایجاد نشده‌است.`;
export const SHOW_SELECT_TEAM_HINT_FOR_SUB_ITEM = subItemName =>
  `با استفاده از این بخش می‌توانید مشخص کنید که در این تیم تنخواه‌داری کدام ${subItemName} نمایش داده شوند.`;
// export const PROJECT_ACCOUNTING_SOFTWARE_HINT =
//   "با فعالسازی و وارد کردن اطلاعات در بخش های زیر می‌توانید خروجی های مورد نظر خود را با فرمت نرم افزار های حسابداری دلخواه خود دریافت نمایید.";
export const PROJECT_ACCOUNTING_SOFTWARE_HINT =
  "در صورتی که نرم‌افزار حسابداری مورد نظر شما جزء نرم‌افزارهای حسابداری تحت پوشش تنخواه‌گردان نمی‌باشد و یا اشکالی در اتصال نرم‌افزار حسابداری با تنخواه‌گردان وجود دارد از طریق لینک زیر به پشتیبانی پیام دهید.";

export const PROJECT_SETTING_CONNECT_TO_PARTNERS_HINT =
  "با فعال‌سازی این بخش، امکان مشاهده و مدیریت گزارش‌های تنخواه در نرم‌افزارهای همکار برای شما فراهم می‌شود. این تنظیمات به شما اجازه می‌دهد تا سیستم تنخواه‌گردان شرکت خود را به‌صورت یکپارچه با نرم‌افزارهای زیر به کار گیرید:";

export const TEAM_LIST_HINT_FOR_COPY_BASIC_INFO =
  "با انتخاب هر یک از تیم‌های تنخواه‌داری زیر، سرفصل‌حساب‌ها، مراکز هزینه، طرف حساب‌ها و هشتگ‌های آن تیم در این تیم تنخواه‌داری نیز قابل مشاهده خواهند بود.";

export const CHANGE_PASSWORD_HINT =
  "با استفاده از شماره تماس و رمز حساب کاربری خود می‌توانید از هر کجا و در هر زمان به اطلاعاتتان دسترسی داشته باشید و برای بالابردن امنیت حساب خود، می‌توانید رمز حساب کاربری خود را به صورت دوره‌ای در این قسمت تغییر دهید.";

export const FILE_HINT =
  "در این صفحه، نسخه‌ای از گزارش دریافتی برای مدت محدودی نگهداری می‌شود و پس از زمان انقضا، لازم است مجددا اقدام به تهیه گزارش و دریافت فایل نمایید.";

export const REMOVE_USERS_WITH_MANAGER_ACCESS_FROM_FINAL_LEVEL_WARNING =
  "مالک و ادمین شرکت به همراه مدیرانی که دارای دسترسی قطعی‌سازی می‌باشند در این سطح قرار می‌گیرند. برای حذف مدیران از این سطح، از بخش مدیریت اعضای تیم می‌توانید دسترسی قطعی‌سازی آن‌ها را تغییر دهید.";

export const SELECT_DATE_ISSUE_WARNING =
  "تاریخ شروع باید تاریخی قبل از تاریخ پایان، یا مطابق با آن باشد.";

export const TRANSACTIONS_MULTI_SELECT_WARNING_TEXT =
  "هیچ تراکنشی انتخاب نشده است.";

export const WARNING_FOR_TRANSACTIONS_IN_IMPREST = state => {
  let text1 = "",
    text2 = "";
  switch (state) {
    case MANAGER_IMPREST_STATES.CONFIRMED:
      text1 = "قبلا توسط شما تایید شده‌";
      text2 = " بنابراین اصلاح این تراکنش توسط شما امکان‌پذیر نمی‌باشد.";
      break;
    case MANAGER_IMPREST_STATES.FINALIZED:
      text1 = "قطعی شده‌";
      text2 =
        "برای اصلاح این تراکنش باید گزارش تنخواه مربوطه از حالت قطعی خارج شود.";
      break;
  }
  if (text1 && text2)
    return `گزارش تنخواهی که این تراکنش در آن قرار دارد، ${text1} است. ${text2}`;
};

export const PETTY_CASH_DELETE_CONFIRM_TEXT =
  "آیا از لغو گزارش تنخواه اطمینان دارید؟ با لغو گزارش های تنخواه، تراکنش‌های گزارش شده در آن حذف نخواهند شد و تنها گزارش تنخواه مربوطه لغو می‌شود.";
export const PETTY_CASH_DELETE_NON_LAST_CONFIRM_TEXT = `با لغو این تنخواه شماره‌ تنخواه‌های بعد از آن یک عدد کمتر می‌شوند، آیا از اعمال این تغییر اطمینان دارید؟`;
export const PETTY_CASH_EDIT_NON_LAST_CONFIRM_TEXT = `در صورت ویرایش این تنخواه، مانده تنخواه‌های بعد از آن تغییر خواهند کرد.`;

export const REJECT_OR_RETURN_WARNING_TEXT = log =>
  `<span class="bold">${getUserIdentification(log.user)}</span> ${
    log.description
  }${
    log.reason
      ? " <br/>" +
        "<span class='bold'>" +
        log.reason.title +
        ":</span> " +
        log.reason.text
      : ""
  }`;

export const REDUNDANT_ACCOUNT_TITLE_IN_BUDGET_FORM = rowNumber =>
  `شما قبلا این سرفصل‌حساب را در ردیف ${rowNumber} اضافه کرده‌اید.`;
export const AT_LEAST_ONE_NON_ZERO_ROW_TO_ADD_BUDGET =
  "ردیف بودجه‌ای برای ثبت وجود ندارد. حداقل باید یک ردیف بودجه غیر صفر وجود داشته باشد.";

export const TRANSACTION_CREATING_OBJECTS_HINT =
  "طرف حساب‌ها، سرفصل‌حساب‌ها، مرکز هزینه‌ها و هشتگ‌های زیر قبلا در این شرکت ایجاد نشده‌اند. آن‌ها را بررسی کنید و در صورت نیاز اصلاح کنید. با برداشتن تیک هر یک از آن‌ها، آن مورد ایجاد نخواهد شد.";
export const TRANSACTION_CREATING_OBJECTS_UN_ACCESSIBLE_HINT = `شما در این شرکت دسترسی ایجاد طرف حساب، سرفصل‌حساب، مرکز هزینه و هشتگ را ندارید. برای ایجاد این موارد به مدیر یا ادمین شرکت می‌توانید اطلاع دهید.`;
export const TRANSACTIONS_IMPORT_FILE_DETAILS = limit => [
  `تعداد تراکنش‌های شما باید کمتر از ${limit} تراکنش باشد. پس از بارگذاری پیش‌نمایشی به شما نشان داده خواهد شد و می‌توانید هر تراکنش خود را ویرایش و سپس ثبت نهایی نمایید.`,
  `خرید یا پرداخت هزینه، عودت شارژ تنخواه، شارژ تنخواه و برگشت از خرید در sheetهای مختلف قرار داده شده‌اند و برای ثبت هر نوع تراکنش باید تراکنش مربوطه در sheet مختص به آن نوع وارد شود.`,
  `اگر تاریخ را خالی بگذارید به طور پیش فرض تاریخ روز جاری لحاظ می‌شود.`,
  `اگر ساعت خالی باشد ساعت جاری لحاظ می‌شود.`,
  `اگر تراکنش شما دارای چندین ریز اقلام است کافی است شماره ردیف آن‌ها را یکی بنویسید و هشتگ‌ها و تاریخ را در ریز اقلام ردیف اول قرار دهید.`,
  `برای هر ردیف تراکنش می‌توانید چندین هشتگ بگذارید که کافی است آن‌ها را با خط تیره از هم جدا کنید.`,
  `اگر سرفصل‌حساب، مرکز هزینه، طرف‌حساب و یا هشتگی از قبل وجود نداشته باشد بعد از بارگذاری تراکنش‌ها در صورت وجود دسترسی شما به ایجاد آن‌ها، توسط سیستم به صورت اتوماتیک ایجاد خواهند شد.`
];
